import { render, staticRenderFns } from "./AsignacionBase.vue?vue&type=template&id=888db46c"
import script from "./AsignacionBase.vue?vue&type=script&lang=js"
export * from "./AsignacionBase.vue?vue&type=script&lang=js"
import style0 from "./AsignacionBase.vue?vue&type=style&index=0&id=888db46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports